import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"flex":"1","display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "form-field-floating reactive my-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-red"
}
const _hoisted_5 = { class: "form-field-floating my-5" }
const _hoisted_6 = ["label"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 1,
  class: "text-red"
}
const _hoisted_9 = { class: "form-field-floating reactive my-4" }
const _hoisted_10 = {
  key: 2,
  class: "text-red"
}
const _hoisted_11 = { class: "form-field-floating reactive my-4" }
const _hoisted_12 = {
  key: 3,
  class: "text-red"
}
const _hoisted_13 = { class: "card-check lg single" }
const _hoisted_14 = { class: "form-check-label" }
const _hoisted_15 = { class: "card-check-text" }

import { ref, reactive, onMounted } from 'vue';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCheckoutAdresseFormModal',
  props: {},
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: null as number | null,
        libelle: "",
        telephone: "",
        adresse: "",
        commune_id: "",
        is_default: false,
    });
    const errors = reactive({
        libelle: "",
        telephone: "",
        adresse: "",
        commune_id: "",
    });
    const communesByVille = reactive({} as { [key: string]: { id: number, nom_commune: string }[] });

    async function _getStartupFormInfos() {
        try {
            const httpResponse = await axios.get(`/market/checkout_form_infos`);
            const data = httpResponse.data;
            const lcommunesByVille: { [key: string]: { id: number, nom_commune: string }[] } = {};
            data.communes.forEach((commune: { id: number, nom_commune: string, ville: string }) => {
                if (!lcommunesByVille[commune.ville]) {
                    lcommunesByVille[commune.ville] = [];
                }
                lcommunesByVille[commune.ville].push(commune);
            });
            Object.assign(communesByVille, lcommunesByVille);
        } catch(error) {
            console.error("Erreur lors de la récupération des infos du formulaire d'adresse de livraison", error);
        }
    }

    async function open(item?: any) {
        await _getStartupFormInfos();
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        if (item) {
            formData.id = item.id;
            formData.libelle = item.libelle;
            formData.telephone = item.telephone;
            formData.adresse = item.adresse;
            formData.commune_id = item.commune_id;
            formData.is_default = item.is_default;
        } else {
            formData.id = null;
            formData.libelle = "";
            formData.telephone = "";
            formData.adresse = "";
            formData.commune_id = "";
            formData.is_default = false;
        }
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
    }

    function onReject() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    function validate() {
        let isValid = true;

        errors.libelle = '';
        if (!formData.libelle) {
            errors.libelle ="Le libellé est requis";
            isValid = false;
        }

        errors.telephone = '';
        if (!formData.telephone) {
            errors.telephone ="Le téléphone est requis";
            isValid = false;
        }

        errors.adresse = '';
        if (!formData.adresse) {
            errors.adresse ="L'adresse est requise";
            isValid = false;
        }

        errors.commune_id = '';
        if (!formData.commune_id) {
            errors.commune_id ="La commune est requise";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                id: formData.id,
                libelle: formData.libelle,
                telephone: formData.telephone,
                adresse: formData.adresse,
                commune_id: formData.commune_id,
            };

            const httpResponse = await axios.post(`/market/save_user_adresse`, formToUpload);
            resolvePromise(httpResponse.data);
            isModalOpen.value = false;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    __expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isModalOpen.value,
    "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((isModalOpen).value = $event)),
    onClosed: onClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(formData.id ? 'Modifier une adresse de livraison' : 'Ajouter une adresse de livraison'), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        id: "btn-confirmation-confirm",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onSubmit
      }, "Valider"),
      _createElementVNode("button", {
        id: "btn-confirmation-reject",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onReject
      }, "Annuler")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.libelle) = $event)),
            name: "libelle",
            id: "libelle",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.libelle]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "libelle" }, [
            _createTextVNode("Nom de l'adresse "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['libelle'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(errors['libelle']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            name: "commune_id",
            id: "commune_id",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.commune_id) = $event))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("option", {
              value: "",
              selected: ""
            }, "Sélectionnez Ville/Commune", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(communesByVille, (communes, ville, index) => {
              return (_openBlock(), _createElementBlock("optgroup", {
                label: ville,
                key: index
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(communes, (commune, subindex) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: commune.id,
                    key: subindex
                  }, _toDisplayString(commune.nom_commune), 9, _hoisted_7))
                }), 128))
              ], 8, _hoisted_6))
            }), 128)),
            _cache[8] || (_cache[8] = _createElementVNode("option", { value: "" }, "Bouaké", -1))
          ], 512), [
            [_vModelSelect, formData.commune_id]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("label", { for: "commune_id" }, [
            _createTextVNode("Sélectionnez Ville/Commune "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['commune_id'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['commune_id']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.adresse) = $event)),
            name: "adresse",
            id: "adresse",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.adresse]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("label", { for: "adresse" }, [
            _createTextVNode("Adresse complete "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['adresse'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(errors['adresse']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.telephone) = $event)),
            name: "telephone",
            id: "telephone",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.telephone]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("label", { for: "telephone" }, [
            _createTextVNode("Numero de téléphone "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['telephone'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(errors['telephone']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input left",
                type: "checkbox",
                name: "is_default",
                id: "is_default",
                value: "1",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.is_default) = $event))
              }, null, 512), [
                [_vModelCheckbox, formData.is_default]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("h6", { class: "font-semibold mt-1 mb-2 align-right" }, "Adresse de livraison par défaut ?", -1))
            ])
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both" }, null, -1))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})